// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.filter-dropdown-menu {\n  min-width: 460px !important;\n  padding: 0 !important;\n}\n.core-tooltip__popper {\n  max-width: 280px !important;\n  font-size: 13px !important;\n  line-height: 1.5 !important;\n}\n", ""]);
// Exports
module.exports = exports;
